import { render, staticRenderFns } from "./translation-tabs.vue?vue&type=template&id=19f2966e"
import script from "./translation-tabs.vue?vue&type=script&lang=ts"
export * from "./translation-tabs.vue?vue&type=script&lang=ts"
import style0 from "./translation-tabs.vue?vue&type=style&index=0&id=19f2966e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports